<template>
  <div
    class="project-docs-reject-history clearfix"
    :class="{'first-record': showRejectHeader}"
  >
    <div class="row clearfix">
      <div class="medium-2 column rejected-date">
        <div
          class="uppercase-bold bottom-margin reject-header"
          v-if="showRejectHeader"
        >{{ $t('date') }}</div>
        <div class="reject-detail">
          <span>{{ formatDate(item.updatedAt) }}</span>
        </div>
      </div>
      <div class="medium-1 column rejected-by">
        <div
          class="uppercase-bold bottom-margin reject-header"
          v-if="showRejectHeader"
        >{{ $t('project.docs.action') }}</div>
        <div class="reject-detail">
          <span style="text-transform: capitalize">{{ item.actionType }}</span>
        </div>
      </div>
      <div class="medium-2 column rejected-by">
        <div
          class="uppercase-bold bottom-margin reject-header"
          v-if="showRejectHeader"
        >{{ $t('actionBy') }}</div>
        <div class="reject-detail">
          <span style="text-transform: capitalize">{{ item.approver.name }}</span>
        </div>
      </div>
      <div class="medium-5 column reject-comment">
        <div
          class="uppercase-bold bottom-margin reject-header"
          v-if="showRejectHeader"
        >{{ $t('comment') }}</div>
        <div class="reject-detail reject-reason">{{ item.detail && item.detail.rejectReason }}</div>
      </div>
      <div class="medium-2 column show-more-link uppercase-bold">
        <div
          class="uppercase-bold bottom-margin reject-header"
          v-if="showRejectHeader"
          style="padding-right: 10px;"
        >{{ $t('project.docs.attachment') }}</div>
        <a
          v-show="showAttachments && showDetailsLink(item)"
          @click="showAttachments = false"
          class="reject-detail"
        >{{ $t('action.showLess') }}</a>
        <a
          v-show="!showAttachments && showDetailsLink(item)"
          @click="showAttachments = true"
          class="reject-detail"
        >{{ $t('action.showMore') }}</a>
      </div>
    </div>
    <div
      v-show="showAttachments"
      class="clearfix"
    >
      <EditAttachments
        :sourceId="item.id"
        :canDowloadAll="isContractor"
      />
    </div>
  </div>
</template>

<script>
import dateUtil from '@/utils/dateUtil'
import EditAttachments from '@/controls/EditAttachments'

export default {
  name: 'RejectHistory',
  components: {
    EditAttachments,
  },
  data () {
    return {
      dateUtil,
      showAttachments: false,
      hasAttachments: false,
    }
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    isContractor: {
      type: Boolean,
      default () { return true },
    },
    showRejectHeader: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    formatDate (dateString) {
      return dateUtil.formatDate(dateString, true)
    },
    showDetailsLink (item) {
      return this.hasAttachments && item.actionType === 'REJECT'
    },
  },
  mounted () {
    this.$on('controls.hkldDropzone.loadFilesLength', (filesCount) => {
      if (filesCount > 0) {
        this.hasAttachments = true
      }
    })
  },
  destroyed () {
    this.$off('controls.hkldDropzone.loadFilesLength')
  },
}
</script>

<style scoped lang="scss">
.project-docs-reject-history.first-record {
  border-top: solid 1px #e0e0e0;
  .reject-header {
    border-bottom: solid 1px #e0e0e0;
  }
}
.project-docs-reject-history.odd-row {
  background-color: white;
}
.project-docs-reject-history {
  color: #0C3A58;
  background-color: #f8f8f8;

  .rejected-date>div{
    padding-left: 10px;
  }

  .rejected-by {
    text-align: center;
  }

  .reject-header {
    background-color: white;
    padding-top: 5px;
    padding-bottom: 5px;
  }

  .reject-detail {
    margin-top: 5px;
    margin-bottom: 5px;
  }
  div a {
    text-decoration: underline;
  }

  h6 {
    font-family: Verdana;
    font-size: 14px;
    margin: 20px 0;
  }

  .row {
    margin: 0;
  }

  .uppercase-bold {
    text-transform: uppercase;
    font-weight: bold;
  }

  .reject-reason{
    padding-right: 20px;
  }

  .column {
    &:first-child {
      padding-left: 0;
    }
    &:last-child {
      padding-right: 0;
    }
  }

  .show-more-link {
    text-align: right;
    a {
      white-space: nowrap;
      padding-right:10px;
    }
  }

  .padding-top {
      padding-top: 32px;
  }
}
</style>

<style lang="scss">
.project-docs-reject-history {
  border: 1px solid #e1e1e1;
  border-top: 0;

  .edit-attachments {
    table {
      border-collapse: collapse;
      color: #0C3A58;
      border: 0;
      margin:0;
    }
    tbody {
      border: 0;
    }
    thead {
      display: none;
    }
    .set-border-top {
      border-top: 0;
    }
    tbody tr:nth-child(even) {
      background-color: #f8f8f8;
    }
    tbody tr:nth-child(odd) {
      background-color: #f8f8f8;
    }
    .number {
      text-align: center;
      width: 42%;
    }
    .filename {
      width: 20%;
      padding: 5px 5px 5px 0;
    }
    .description {
      width: 46%;
      padding: 5px;
    }
    .uploaded-at, .attachment-index {
      display: none;
    }
  }
}
</style>
